import { FC, ReactNode } from 'react';

import { Box, forwardRef, TabProps, useTab } from '@bonusly/design-system';

import { getStyle } from './style';

interface BonusFeedTabProps extends TabProps {
	children: ReactNode;
}

export const HighlightTab: FC<BonusFeedTabProps> = forwardRef(({ children, ...props }, ref) => {
	const tabProps = useTab({ ...props, ref });
	const isSelected = !!tabProps['aria-selected'];

	return (
		<Box as="button" {...getStyle(isSelected)} {...tabProps}>
			{children}
		</Box>
	);
});
